(ns frontend.view.grid.surveys-grid.db
  (:require
   [frontend.db :as app-db]
   [reagent.core :as r]))

(defonce survey-profiles (r/cursor app-db/views [:surveys-grid]))
(defonce grid-entities (r/cursor survey-profiles [:grid-entities]))
(defonce view-settings (r/cursor survey-profiles [:view-settings]))
(defonce survey-profile-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor survey-profiles [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor survey-profiles [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor survey-profiles [:schema]))
